import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'SnippetEditor',
  properties: {
    cloneId: String,
    recommendedAnswerId: String,
    referencedAnswerId: String,
    snippetId: String,
  },

  statics: {
    breadcrumb: 'Answer',
  },
});
